<template>
  <div id="page">
    <div>
      <b-container align="left">
        <div>
          <h3>请填写您的邮寄地址</h3>
        </div>

        <div>所在地区 北京 西城区</div>

        <div>
          <b-form-textarea
            id="textarea-no-resize"
            placeholder="邮寄地址具体到门牌号"
            rows="2"
            v-model="mailAddress"
            no-resize
          ></b-form-textarea>
        </div>

        <div>
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
          >
            《中国农业银行借记卡章程》
          </b-form-checkbox>
        </div>

        <div align="center" class="actionArea">
          <b-button
            block
            variant="success"
            style="width: 80%"
            @click="submitUserInfo()"
            >下一步</b-button
          >
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MailAddress",
  data() {
    return {
      status: "not_accepted",
      name: "",
      idNo: "",
      mobile: "",
      smsCode: "",
      mailAddress: "北京市西城区新盛大厦B-8层",
    };
  },
  methods: {
    toSelectCardface: function (bankSerialNumber) {
      this.$router.push({
        name: "SelectCardface",
        params: {
          bankSerialNumber: bankSerialNumber,
        },
      });
    },
    submitUserInfo: function () {
      var that = this;
      //
      axios
        .post("https://cp.hengbao.net.cn/pos/order/submitUserInfo", {
          idNo: this.idNo,
          address: this.mailAddress,
        })
        .then(function (response) {
          // {code: 0, message: "交易成功", backSerialNumber: "2d506a29aaf846d3947ce1acfa9b38ad"}
          console.log(response);
          var data = response.data;
          if (0 === data.code) {
            that.toSelectCardface(data.backSerialNumber);
          } else {
            console.log("提交用户信息失败：" + data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    testAxios: function () {
      axios
        .get("http://localhost:8080")
        .then(function (res) {
          alert(res.data);
        })
        .catch(function (ex) {
          alert(ex);
        });
    },
  },
  mounted: function () {
    var param_identiy = this.$route.params.identiy;
    var identiy = JSON.parse(param_identiy);
    this.name = identiy.name;
    this.idNo = identiy.idNo;
    this.mobile = identiy.mobile;
    this.smsCode = identiy.smsCode;
    console.log("param_identiy:" + param_identiy);
  },
};
</script>

<style scoped>
.actionArea {
  margin-top: 32px;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/MailAddress.vue